import React from "react"
import styled from "styled-components"
import breakpoints from "../../styles/breakpoints"
import { H2Style } from "../Core/Engagement/Styles"
import { withTranslation } from "gatsby-plugin-react-i18next"
import CollectionCarousel from "../Core/CollectionCarouselPDP"

const StyledContainer = styled.div`
  a {
    text-decoration-thickness: 1px;
    text-underline-offset: 2px;
  }

  @media (min-width: ${breakpoints.md}) {
    margin: 55px auto;
  }
`

const Container = styled.div`
  width: 100%;
  padding: 0 13px;

  @media (min-width: ${breakpoints.lg}) {
    padding: 0 32px;
  }
`

const Content = styled.div`
  margin: auto;
  max-width: ${breakpoints.xxl};
`

const Border = styled.hr`
  margin-top: 50px;
  border-top: 1px solid #cacaca;
`

const CarouselTitle = styled.div`
  ${H2Style};
  padding-top: 34px;
  margin-bottom: 24px;
  border-top: 1px solid #cacaca;
`

const SliderContainer = styled.div`
  @media (min-width: ${breakpoints.lg}) {
    padding: 0 42px;
  }
`

const Collections = ({ t }) => {
  return (
    <StyledContainer>
      <Container>
        <Content>
          <CarouselTitle>{t("pdp.collections.ourbestsellers")}</CarouselTitle>
        </Content>
      </Container>
      <SliderContainer>
        <CollectionCarousel />
      </SliderContainer>
      <Container>
        <Content>
          <Border />
        </Content>
      </Container>
    </StyledContainer>
  )
}

export default withTranslation()(Collections)
